import { getFreeBetState } from 'automaton/states/FreeBetState'

import { signal } from '../../services/SignalsService'
import { getFreeBetAddAction } from '../actions/FreeBetAddAction'
import { getFreeBetSetBetAction } from '../actions/FreeBetSetBetAction'

export function getFreebetAddState() {
  const name = 'FB-ADD'
  signal.dispatch('FREEBET:SHOW:POPUP', true)
  const actions =  [getFreeBetAddAction(), getFreeBetSetBetAction()]
  const transition = () => getFreeBetState()

  return {
    name,
    actions,
    transition,
  }
}
